import { render, staticRenderFns } from "./UserConfirmOTP.vue?vue&type=template&id=56a0570e&scoped=true&"
import script from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
export * from "./UserConfirmOTP.vue?vue&type=script&lang=js&"
import style0 from "./UserConfirmOTP.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserConfirmOTP.vue?vue&type=style&index=1&id=56a0570e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0570e",
  null
  
)

export default component.exports